export const GENRES = [
  "Tech House", "House", "Deep House", "Afro House", "Melodic House & Techno", "Progressive House",
  "Techno (Peak Time / Driving)", "Techno (Raw / Deep / Hypnotic)", "Hard Techno", "Minimal / Deep Tech",
  "Indie Dance", "Nu Disco / Disco", "Organic House / Downtempo", "Jackin House", "Funky House",
  "Bass House", "Electro", "Breaks", "Trance", "Drum & Bass", "Dubstep", "Electronica",
];

export const KEYS = ["1A", "2A", "3A", "4A", "5A", "6A", "7A", "8A", "9A", "10A", "11A", "12A", "1B", "2B", "3B", "4B", "5B", "6B", "7B", "8B", "9B", "10B", "11B", "12B"];

export const slugify = (s = "") => s.toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

const HUES = ["#1fe896", "#ff4fa3", "#38bdf8", "#ffb547", "#a78bfa", "#f87171", "#34d399", "#fb923c"];
export const genreColor = (name = "") => HUES[[...name].reduce((a, c) => a + c.charCodeAt(0), 0) % HUES.length];
